import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { useGetGroup } from "@services/apiEcms/useGetGroup";
import { usePostUsers } from "@services/apiEcms/usePostUsers";

import type { NewUserForm } from "./AccessManager.types";

export const useCreateUser = () => {
  const mutation = usePostUsers();
  const { currentGroup } = useGroupReferences();

  // TODO: when x-group is activated on header, this should be removed both from Front and Back
  const { data: groupName } = useGetGroup({
    groupId: currentGroup,
    options: {
      select: (res) => res.group.name,
    },
  });

  const mutateFunction = (newUser: NewUserForm) => {
    try {
      return mutation.mutate({ ...newUser, group: groupName || "" });
    } catch (error) {
      return error;
    }
  };
  return {
    ...mutation,
    mutateFunction,
  };
};
